export default "__VITE_ASSET__BgStaQEk__"